module.exports = __webpack_public_path__ + "static/media/Mario.e0a4c35a.gif";